import {  Component, OnInit } from '@angular/core';
import { AddressInterface } from '../../models/address.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CheckPasswordInterface } from '../../../shared/models/check-password.interface';
import { MfaInterface } from '../../../shared/models/mfa.interface';
import { Router } from '@angular/router';
import { CustomerStorageService } from '../../services/customer-storage.service';
import { select, Store } from '@ngrx/store';
import { ExtranetService } from '../../../shared/services/extranet.service';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { CheckPasswordInterfaceState } from '../../../shared/store/state/check-password.state';
import { ConfirmationAddressInterfaceState } from '../../store/state/confirmation-address.state';
import { UpdateMfaVisibility } from '../../../shared/store/actions/mfa.actions';
import { MfaInterfaceState } from '../../../shared/store/state/mfa.state';
import { CreateShippingAddress, EAddressActions } from '../../store/actions/address.actions';
import { Actions, ofType } from '@ngrx/effects';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { CustomerInterface } from '../../models/customer.interface';
import { UpdateCheckPasswordVisibility } from '../../../shared/store/actions/check-password.actions';

@Component({
    selector: 'app-create-shipping-address',
    templateUrl: './create-shipping-address.component.html',
    styleUrls: ['./create-shipping-address.component.css'],
    standalone: false
})
export class CreateShippingAddressComponent implements OnInit {
  addressFrom: FormGroup;
  addressFromSubmitted: boolean;
  passwordResponse: CheckPasswordInterface;
  mfaResponse: MfaInterface|null;
  display: string = null;
  customer: CustomerInterface;

  errors: any = {
    lastName: {
      required: `Le nom est obligatoire.`,
      pattern: 'Veuillez saisir un nom sans accent, caractères spéciaux ni chiffres.'
    },
    firstName: {
      required: `Le prénom est obligatoire.`,
      pattern: `Veuillez saisir un prénom sans accent, caractères spéciaux ni chiffres.`
    },
    company: {
      pattern: `Veuillez saisir un nom de société sans accent ni caractères spéciaux.`
    },
    label: {
      required: `Le nom d'adresse est obligatoire.`,
      pattern: `Veuillez saisir un nom d'adresse avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    },
    street: {
      required: `L'adresse' est obligatoire.`,
      pattern: `Veuillez saisir une adresse avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    },
    zipCode: {
      required: `Le code postal est obligatoire.`,
      pattern: `Le code postal saisie n'est pas valide.`
    },
    city: {
      required: `La ville est obligatoire.`,
      pattern: `Veuillez saisir un nom de ville sans accent, caractères spéciaux ni chiffres.`
    },
    addressComplement: {
      pattern: `Veuillez saisir un complément d\'adresse avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    },
    placeName: {
      pattern: `Veuillez saisir un lieu-dit avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    }
  };

  constructor(
      private formBuilder: FormBuilder,
      private router: Router,
      private actions$: Actions,
      private customerStorageService: CustomerStorageService,
      private store: Store<any>,
      private extranetService: ExtranetService
  ) { }

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_CHECK_PASSWORD)).subscribe((response: CheckPasswordInterfaceState) => {
      if (response.result && response.result.isValid === true && response.result.page === 'add-shipping-address') {
        this.passwordResponse = response.result;
        this.initShippingAddressFrom();
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CONFIRMATION_ADDRESS)).subscribe( (result: ConfirmationAddressInterfaceState) => {
      if (null != result.visibility) {
        this.display = result.visibility ? 'block' : 'none';
        if (this.display === 'block' && this.extranetService.getSupportUser() == null) {
          this.mfaResponse.visibility = false;
          this.store.dispatch(new UpdateMfaVisibility(this.mfaResponse));
        }
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_MFA)).subscribe((response: MfaInterfaceState) => {
      if (response.result != null) {
        this.mfaResponse = response.result;
      }
    });

    this.actions$.pipe(ofType(EAddressActions.CreateShippingAddressSuccess)).subscribe((result: any) => {
      this.store.dispatch(new GetAlertMessage({ message: 'Votre adresse de livraison a bien été créée.', code: 200 }));
      window.location.reload();
    });

    this.display = null;
    this.mfaResponse = null;
    this.customer = this.customerStorageService.getCustomer();
    this.addressFromSubmitted = false;
    if (!this.passwordResponse || this.passwordResponse.isValid === false) {
      this.router.navigate(['compte/adresses']);
    }
  }

  /**
   * Init shipping address form
   */
  initShippingAddressFrom() {
    this.addressFrom = this.formBuilder.group({});
    this.addressFrom.addControl('civility', this.formBuilder.control('Mr', [Validators.required]));
    this.addressFrom.addControl('firstName', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.firstNamePattern)]));
    this.addressFrom.addControl('lastName', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.lastNamePattern)]));
    this.addressFrom.addControl('company', this.formBuilder.control('', [Validators.pattern(ConstsHelper.companyPattern)]));
    this.addressFrom.addControl('label', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.addressPattern)]));
    this.addressFrom.addControl('street', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.addressPattern)]));
    this.addressFrom.addControl('addressComplement', this.formBuilder.control('', [Validators.pattern(ConstsHelper.addressPattern)]));
    this.addressFrom.addControl('zipCode', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.zipCodePattern)]));
    this.addressFrom.addControl('city', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.cityPattern)]));
    this.addressFrom.addControl('placeName', this.formBuilder.control('', [Validators.pattern(ConstsHelper.addressPattern)]));
  }

  /**
   * Save data
   */
  save() {
    this.addressFromSubmitted = true;
    if (this.addressFrom.valid) {
      this.saveShippingAddress(false);
      this.addressFromSubmitted = false;
    }
  }

  goToAddressPage() {
    this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: false, isValid: false, password: null, page: null}));
    this.router.navigate(['/compte/adresses']);
  }

  byPassGoogleCheckAddressApi() {
    this.display = null;
    this.saveShippingAddress(true);
  }

  closeModal() {
    this.display = null;
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.addressFrom.controls[formControlName].invalid) {
      Object.keys(this.addressFrom.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }

  private saveShippingAddress(byPassGoogleCheck: boolean) {
    const address = {
      civility : this.addressFrom.get('civility').value,
      firstName : this.addressFrom.get('firstName').value,
      lastName : this.addressFrom.get('lastName').value,
      company : this.addressFrom.get('company').value,
      street : this.addressFrom.get('street').value,
      addressComplement : this.addressFrom.get('addressComplement').value,
      zipCode : this.addressFrom.get('zipCode').value,
      city : this.addressFrom.get('city').value,
      placeName : this.addressFrom.get('placeName').value,
      label : this.addressFrom.get('label').value,
      byPassGoogleCheck,
      password : this.passwordResponse.password
    } as AddressInterface;
    document.getElementById('wrapper-content').scrollTop = 0;
    if (this.extranetService.getSupportUser()) {
      address.customerId = this.customer.id;
      address.byPassGoogleCheck = true;
      this.store.dispatch(new CreateShippingAddress(address));
    } else if (byPassGoogleCheck) {
      this.store.dispatch(new CreateShippingAddress(address, this.mfaResponse));
    } else {
      this.store.dispatch(
          new UpdateMfaVisibility(
              {
                visibility: true,
                action: 'create_shipping_address',
                step: (this.mfaResponse !== null) ? this.mfaResponse.step : 1,
                destination: (this.mfaResponse !== null) ? this.mfaResponse.destination : null,
                code: (this.mfaResponse !== null) ? this.mfaResponse.code : null,
                errorMessage: (this.mfaResponse !== null) ? this.mfaResponse.errorMessage : null,
                effect: CreateShippingAddress,
                effectData: address
              }
          )
      );
    }
  }

}
